import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { confirmBill } from '../api/parking-billing.ts';

export default function useConfirmBilling(): UseMutationResult<
  string,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => confirmBill(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['unconfirmedBillings'] });
      queryClient.invalidateQueries({ queryKey: ['confirmedBillings'] });
    },
  });
}
